import { FormattedDate, FormattedHTMLMessage } from 'react-intl'
import { isMobileSelector } from '../../selectors/device'
import { Link } from 'react-router-dom'
import { SongPropType } from 'spa/api/songs'
import { SongTableRowTitle } from './song_table_row_title'
import { SongVersionsPopover } from './song_versions_popover'
import { TableSeparator } from './table_separator'
import { TextStyle } from '../typography'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import find from 'lodash/find'
import first from 'lodash/first'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import styles from './styles'

export const SongTableRow = ({
  showDateAdded,
  index,
  listIndex,
  onAddSongToQueue,
  onRemoveSongFromQueue,
  onSelect,
  song,
  currentlyInQueue,
  trackList,
}) => {
  const isMobile = useSelector(isMobileSelector)
  const primaryCategory = first(song.tags, x => x.name === song.category)
  const categoryId = primaryCategory ? primaryCategory.id : song.categoryId
  const tags = useSelector(state => state.tags.tags)
  const tag = find(tags, { id: categoryId })
  const [isOpen1, setIsOpen1] = useState(false)
  const [isOpen2, setIsOpen2] = useState(false)

  const customDateFormat = date => {
    const days = (Date.now() - new Date(date).getTime()) / (1000 * 3600 * 24)

    if (days < 1)
      return (
        <FormattedHTMLMessage
          defaultMessage="Today"
          id="djcity.records.recordpool.track.date_added.today"
        />
      )

    if (days < 2)
      return (
        <FormattedHTMLMessage
          defaultMessage="Yesterday"
          id="djcity.records.recordpool.track.date_added.yesterday"
        />
      )

    if (days < 8)
      return (
        <FormattedHTMLMessage
          defaultMessage="{n} days ago"
          id="djcity.records.recordpool.track.date_added.n_days_ago"
          values={{ n: Math.floor(days) }}
        />
      )

    return (
      <FormattedDate
        day="numeric"
        month="short"
        value={new Date(date)}
        year="numeric"
      />
    )
  }

  return (
    <div
      className={classNames(styles.tableRowContainer, {
        [styles.tableRowContainerOpen]: isOpen1 || isOpen2,
      })}
    >
      <SongTableRowTitle
        listIndex={listIndex}
        numberIndex={index}
        onSelect={onSelect}
        song={song}
        trackList={trackList}
      />
      {!isMobile && (
        <>
          {showDateAdded && (
            <TextStyle color="grey">
              {customDateFormat(song.insertDate)}
            </TextStyle>
          )}
          <TextStyle variant="bold">{song.bpm}</TextStyle>
          {tag && (
            <div>
              <Link to={`/genre/${tag.slug}`}>
                <TextStyle
                  className={styles.genreCell}
                  color="red"
                  variant="bold"
                >
                  {song.category.substring(0, 25)}
                </TextStyle>
              </Link>
            </div>
          )}
        </>
      )}
      {!isMobile && (
        <div className={styles.actionButton}>
          <SongVersionsPopover
            buttonIcon="arrow-alt-circle-down"
            currentlyInQueue={currentlyInQueue}
            onAddSongToQueue={onAddSongToQueue}
            onRemoveSongFromQueue={onRemoveSongFromQueue}
            setIsOpen={setIsOpen1}
            songId={song.rid}
            trackList={trackList}
          />
        </div>
      )}
      <div className={styles.actionButton}>
        <SongVersionsPopover
          buttonIcon="ellipsis-h"
          currentlyInQueue={currentlyInQueue}
          onAddSongToQueue={onAddSongToQueue}
          onRemoveSongFromQueue={onRemoveSongFromQueue}
          setIsOpen={setIsOpen2}
          songId={song.rid}
          trackList={trackList}
        />
      </div>
      <TableSeparator />
    </div>
  )
}

export default SongTableRow

SongTableRow.propTypes = {
  currentlyInQueue: PropTypes.bool,
  index: PropTypes.number,
  listIndex: PropTypes.number,
  onAddSongToQueue: PropTypes.func,
  onRemoveSongFromQueue: PropTypes.func,
  onSelect: PropTypes.func,
  showDateAdded: PropTypes.bool,
  song: SongPropType,
  trackList: PropTypes.string,
}
